import { useNavigate } from "react-router-dom";
// ui components
import TimeAgo from 'react-timeago'
import { ParagraphXSmall } from 'baseui/typography';
import { Block } from 'baseui/block';
import { useStyletron } from 'baseui';
import { ListItem, ListItemLabel } from 'baseui/list';
// custom ui components
import { AckUserInfo } from './AckUserInfo'
import { AckAlarmButton } from './AckAlarmButton'
// services
import { isAcknowledged, AlarmDetailsDto, getBehavior, needsAcknowledge } from '../../services/alarm'
import { Button, SHAPE } from 'baseui/button';
import { ChevronRight } from 'baseui/icon';
import { HierarchyObjectNavigation } from '../../components/HierarchyNavigation'
import { IoCalendarOutline } from "react-icons/io5";
import { BsStopwatch } from "react-icons/bs";
import { timespanToString } from "../../utils/timeUtils";
import { useIntl, FormattedMessage } from 'react-intl';
import { useTimeAgoFormatter } from "../../hooks/useTimeAgoFormatter";
import { getAlarmClassStyle } from "./alarmClassStyles";
import { Tag } from "baseui/tag";
import useIntlAlarmMessage from "../../hooks/useIntlAlarmMessage/useIntlAlarmMessage";
import { Badge } from "baseui/badge";


export const AlarmListItem: React.FC<{ alarms: AlarmDetailsDto[], small?: boolean, count: number }> = (props) => {
    const { alarms, small, count} = props
    const [, theme] = useStyletron();
    const navigate = useNavigate();

    const alarm = alarms[0];
    const style1 = getAlarmClassStyle(alarm.alarmClass.name, alarm.offTime !== undefined && alarm.offTime !== null, theme);
    const behavior = getBehavior(alarm);
    const hasAlarmToAck = alarms.some(elm => !isAcknowledged(elm));

    return (
        <ListItem overrides={{
            Root: {
                style: {
                    backgroundColor: style1?.backgroundColor,
                    color: style1?.color,
                    borderRadius: theme.sizing.scale500
                }
            }
        }}
            endEnhancer={() => (
                <>
                    {(hasAlarmToAck && !small) &&
                        (<AckAlarmButton alarms={alarms} />)
                    }
                    <Button onClick={() => navigate(`/alarms/${alarm.resourceGroupId}/${alarm.id}`)} size="compact" kind="tertiary" shape="pill">
                        <ChevronRight size={theme.sizing.scale800} />
                    </Button>
                </>
            )}
        >
            <Block width='100%' display='flex' flexWrap flexDirection='row' alignItems='center' justifyContent='space-between' padding={theme.sizing.scale200} gridGap={theme.sizing.scale200}>
                <Block display='flex' flexDirection='row' alignItems='center' gridGap={theme.sizing.scale500}>
                    {style1?.icon}

                    <Header count={count} alarm={alarm} behavior={behavior}></Header>
                </Block>
                <Block display='flex' flexDirection='row' alignItems='center' gridGap={theme.sizing.scale800}>
                    <AckInfo {...alarm}></AckInfo>
                    <AlarmTime {...alarm}></AlarmTime>
                </Block>
            </Block>
        </ListItem>
    );
}

function Header({ alarm, behavior, style1, count }: any) {
    const intl = useIntl();
    const [css, theme] = useStyletron();
    const alarmMessage = useIntlAlarmMessage(alarm);

    return (
        <ListItemLabel overrides={{
            LabelContent: {
                style: ({ $theme }) => ({
                    color: style1?.color
                })
            }
        }}
            description={
                <Block display='inline'>

                    <HierarchyObjectNavigation className={css({ fontSize: theme.typography.ParagraphXSmall.fontSize })}
                        resourceGroupId={alarm.object.resourceGroupId}
                        objectId={alarm.objectId} currentAsLink={true} current={alarm.object.name} currentDescription={alarm.object.description} showDescription={true}></HierarchyObjectNavigation>
                    <Tag closeable={false} color={theme.colors.primary} kind="custom" variant="outlined" size="small" overrides={{
                        Root: {
                            style: ({ $theme }) => ({
                                borderWidth: '1px',
                                marginLeft: '0px',
                                opacity: 0.6,
                            })
                        },
                        Text: {
                            style: ({ $theme }) => ({
                                fontSize: theme.typography.ParagraphXSmall.fontSize,
                            })
                        }
                    }}>{intl.formatMessage({ id: `alarmClassNames.${alarm.alarmClass.name}`, defaultMessage: alarm.alarmClass.name })}</Tag>
                </ Block>
            }>

            {count > 1 && <span className={css({ marginRight: theme.sizing.scale300 })}><Badge color={'primary'} content={count} shape={SHAPE.pill} /></span>}
            {alarmMessage}

        </ListItemLabel>
    )
}



function AlarmTime(alarm: AlarmDetailsDto) {

    const { formatter } = useTimeAgoFormatter();
    //const formatter = buildFormatter(deStrings);

    const content = !alarm.offTime ? (
        <ParagraphXSmall  >  <span><IoCalendarOutline></IoCalendarOutline> <TimeAgo date={alarm.onTime} formatter={formatter} /></span></ParagraphXSmall>) :
        (<ParagraphXSmall><b><FormattedMessage id='alarms.gone' defaultMessage='gone' /></b> <span><IoCalendarOutline></IoCalendarOutline> <TimeAgo date={alarm.onTime} formatter={formatter} /></span></ParagraphXSmall>)

    return (<Block display='flex' flexDirection='column'>
        {content}
        {alarm.duration && <ParagraphXSmall marginTop={0}>
            <>
                <BsStopwatch ></BsStopwatch>
                <span> {timespanToString(Math.round(alarm.duration))}</span>
            </>
        </ParagraphXSmall>}
    </Block>)
}

function AckInfo(alarm: AlarmDetailsDto) {
    if (!isAcknowledged(alarm) || !needsAcknowledge(alarm))
        return (<></>)
    return (<AckUserInfo userId={alarm.ackUserId} userName={alarm.ackUser || ''} time={alarm.ackTime} />)
}